import { render, staticRenderFns } from "./doctorDetails.vue?vue&type=template&id=71fc573a&scoped=true"
import script from "./doctorDetails.vue?vue&type=script&lang=js"
export * from "./doctorDetails.vue?vue&type=script&lang=js"
import style0 from "./doctorDetails.vue?vue&type=style&index=0&id=71fc573a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc573a",
  null
  
)

export default component.exports